// extracted by mini-css-extract-plugin
export default {"iframe":"Main_iframe__iw9yb","root":"Main_root__f8Ccz","panel":"Main_panel__VHoZn","h2":"Main_h2__o71uT"};